import { Text } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

export const EmptyMessage: FC<{ children: ReactNode }> = ({ children }) => {
  return <Text color="gray.500">{children}</Text>
}
